/**
 * @desc 财务税务表分页查询
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.IPage<defs.tms.FinanceAndTaxationMasterResponseDto>
>;
export function request(
  params: API.tms.stockOccupyDetail.financeAndTaxationPage.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/stockOccupyDetail/financeAndTaxationPage`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
